import React, { useState } from 'react';
import styles from './DENTHistoryItem.module.scss';
import DENTHistoryItemLogs from './DENTHistoryItemLogs';
import { joinClasses } from '../../../../../Utils/className.util';
import DENTHistoryItemMedicalExamination from './DENTHistoryItemMedicalExamination';
import { MedicalExamination } from '../../../../../graphql/graphql';

interface Props {
	item: MedicalExamination;
	reload: () => void;
}

const DENTHistoryItem = ({ item, reload }: Props) => {
	const [showLogs, setShowLogs] = useState(false);

	return (
		<div className={styles.wrapper}>
			<DENTHistoryItemMedicalExamination
				item={item}
				onClick={() => setShowLogs(!showLogs)}
			/>
			<div
				className={joinClasses([
					styles.listWrapper,
					showLogs ? styles.expanded : '',
				])}>
				<DENTHistoryItemLogs logs={item.toothLogs} reload={reload} />
			</div>
		</div>
	);
};

export default DENTHistoryItem;
